import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Download, Upload, MessageSquare, Heart } from "lucide-react";

interface GameStatsBoxProps {
  game: {
    downloads: number;
    uploads?: number;
    comments: number;
    likes: number;
    releaseDate: string; // Feltöltés ideje helyett kiadás dátuma
  };
}

const GameStatsBox: React.FC<GameStatsBoxProps> = ({ game }) => {
  return (
    <Card className="bg-gray-800 text-secondary-foreground border-border shadow-md">
      <CardHeader>
        <CardTitle className="text-xl font-bold text-primary">Statisztikák</CardTitle>
      </CardHeader>
      <CardContent className="grid grid-cols-2 gap-4 text-sm">
        <div className="flex items-center gap-2">
          <Download size={18} className="text-blue-500" />
          <span>Letöltések: <span className="font-semibold">{(game.downloads ?? 0).toLocaleString()}</span></span>
        </div>
        <div className="flex items-center gap-2">
          <Upload size={18} className="text-green-500" />
          <span>Feltöltések: <span className="font-semibold">{(game.uploads ?? 0).toLocaleString()}</span></span>
        </div>
        <div className="flex items-center gap-2">
          <MessageSquare size={18} className="text-yellow-500" />
          <span>Hozzászólások: <span className="font-semibold">{(game.comments ?? 0).toLocaleString()}</span></span>
        </div>
        <div className="flex items-center gap-2">
          <Heart size={18} className="text-red-500" />
          <span>Lájkok: <span className="font-semibold">{(game.likes ?? 0).toLocaleString()}</span></span>
        </div>
      </CardContent>
    </Card>
  );
};


export default GameStatsBox;